import { Component,Inject, OnDestroy, OnInit,ViewChild, AfterViewInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEventType  } from '@angular/common/http';
import { Subscription, throwError} from 'rxjs';
import { DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { catchError } from 'rxjs/operators'

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faDollarSign,faChartLine, faFileExcel,faFilePowerpoint,faFilePdf, faProjectDiagram, faInfo, faQuestionCircle, faClipboardList,
  faMap,faDraftingCompass,faImage, faChevronCircleRight, faChevronCircleLeft,faPlus,faEdit, faListOl,faHistory, faEllipsisH, faHandshakeAltSlash, faListAlt, faStar, faExpandArrowsAlt, faMinus, faFlask, faFileDownload, faFileImage, faFileUpload, faSearch, faRedo, faSitemap, faExchangeAlt} from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

import { NavigationService } from '../services/navigation.service';
import { AccountService } from '../services/account.service';
import { VersionService } from '../services/version.service';

import { AccountStatusService } from '../services/accountstatus.service';
import { UserService } from '../services/user.service';
import { AssetMapService } from '../services/assetmap.service';
import { EntityService } from '../services/entity.service';
import { LogoService } from '../services/logo.service';
import { VersionsComponent } from './versions/versions.component';
import { ImportDialogComponent } from './import-dialog/import-dialog.component';
import { SubAccountComponent } from './sub-account/sub-account.component';

import { ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import { addEntityProperty, initSessionName, sfdcAccountFilters, isDevEnv } from '../services/util.service';

const CLEAN_VIEW_ICON = `
  <svg t="1632887944816" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8270" width="50" height="50"><path d="M840.512 418.816l160.512 69.76a25.6 25.6 0 0 1 0 46.912l-463.552 201.28a64 64 0 0 1-50.944 0L22.976 535.488a25.6 25.6 0 0 1 0-46.976l160.256-69.632 277.504 120.512a128 128 0 0 0 102.016 0l277.76-120.576z" fill="#e0e0e0" p-id="8271" data-spm-anchor-id="a313x.7781069.0.i21" class=""></path><path d="M840.512 674.816l160.512 69.76a25.6 25.6 0 0 1 0 46.912l-463.552 201.28a64 64 0 0 1-50.944 0L22.976 791.488a25.6 25.6 0 0 1 0-46.976l160.256-69.632 277.504 120.512a128 128 0 0 0 102.016 0l277.76-120.576z" fill="#4db6b1" p-id="8272" data-spm-anchor-id="a313x.7781069.0.i24" class=""></path><path d="M537.472 31.232l463.552 201.28a25.6 25.6 0 0 1 0 46.976L537.472 480.768a64 64 0 0 1-50.944 0L22.976 279.488a25.6 25.6 0 0 1 0-46.976L486.528 31.232a64 64 0 0 1 50.944 0z" fill="#e0e0e0" p-id="8273" data-spm-anchor-id="a313x.7781069.0.i23" class=""></path></svg>
`;
const INTERIM_VIEW_ICON = `
  <svg t="1632887944816" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8270" width="50" height="50"><path d="M840.512 418.816l160.512 69.76a25.6 25.6 0 0 1 0 46.912l-463.552 201.28a64 64 0 0 1-50.944 0L22.976 535.488a25.6 25.6 0 0 1 0-46.976l160.256-69.632 277.504 120.512a128 128 0 0 0 102.016 0l277.76-120.576z" fill="#4db6b1" p-id="8271" data-spm-anchor-id="a313x.7781069.0.i21" class=""></path><path d="M840.512 674.816l160.512 69.76a25.6 25.6 0 0 1 0 46.912l-463.552 201.28a64 64 0 0 1-50.944 0L22.976 791.488a25.6 25.6 0 0 1 0-46.976l160.256-69.632 277.504 120.512a128 128 0 0 0 102.016 0l277.76-120.576z" fill="#4db6b1" p-id="8272" data-spm-anchor-id="a313x.7781069.0.i24" class=""></path><path d="M537.472 31.232l463.552 201.28a25.6 25.6 0 0 1 0 46.976L537.472 480.768a64 64 0 0 1-50.944 0L22.976 279.488a25.6 25.6 0 0 1 0-46.976L486.528 31.232a64 64 0 0 1 50.944 0z" fill="#e0e0e0" p-id="8273" data-spm-anchor-id="a313x.7781069.0.i23" class=""></path></svg>
`;
const DETAIL_VIEW_ICON = `
  <svg t="1632887944816" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8270" width="50" height="50"><path d="M840.512 418.816l160.512 69.76a25.6 25.6 0 0 1 0 46.912l-463.552 201.28a64 64 0 0 1-50.944 0L22.976 535.488a25.6 25.6 0 0 1 0-46.976l160.256-69.632 277.504 120.512a128 128 0 0 0 102.016 0l277.76-120.576z" fill="#4db6b1" p-id="8271" data-spm-anchor-id="a313x.7781069.0.i21" class=""></path><path d="M840.512 674.816l160.512 69.76a25.6 25.6 0 0 1 0 46.912l-463.552 201.28a64 64 0 0 1-50.944 0L22.976 791.488a25.6 25.6 0 0 1 0-46.976l160.256-69.632 277.504 120.512a128 128 0 0 0 102.016 0l277.76-120.576z" fill="#4db6b1" p-id="8272" data-spm-anchor-id="a313x.7781069.0.i24" class=""></path><path d="M537.472 31.232l463.552 201.28a25.6 25.6 0 0 1 0 46.976L537.472 480.768a64 64 0 0 1-50.944 0L22.976 279.488a25.6 25.6 0 0 1 0-46.976L486.528 31.232a64 64 0 0 1 50.944 0z" fill="#4db6b1" p-id="8273" data-spm-anchor-id="a313x.7781069.0.i23" class=""></path></svg>
`;

@Component({
  selector: 'app-architecture',
  templateUrl: './architecture.component.html',
  styleUrls: ['./architecture.component.scss']
})
export class ArchitectureComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('slview', { static: false }) slView: any;
  @ViewChild('slusecases', { static: false }) slUseCases: any;
  @ViewChild('slassetmap', { static: false }) slAssetMap: any;
  @ViewChild('filtering', { static: false }) filtering: any;


  public activatedQuery$ : Subscription;
  private stackColors$: Subscription;
  stackColors: any[] = [];
  offeringLayersLoaded = false;
  handlenavigate:boolean = false;
  init:boolean = true;
  sAccountInitId=null; //use to set the drop down when val comes from querystring
  sVersionInitId=null; //use to pick the right version if the val comes from querystring

  zoom=100;
  tempZoom = 100;
  scale = 1;
  fitWidth = true;
  fitHeight = true;
  isFitPage=false;
  isData=false;
  isLoading=true;
  loading = 0;
  finishLoadingStatus = false;
  isLoadingStatus = true;
  sAccount=null;
  sVersion=null;
  sVersionName="";
  page=1;
  tableView="regular";
  matTooltipShow: boolean = true;
  healthHideEntities=true;
  showRestrictedFilter: boolean = false;
  isLoadingUser: boolean = true;

  private accountsData$: Subscription;
  accountsData:any={
    data:[]
  };
  originalAccountsData:any = {
    data: []
  };
  private accountsListData$: Subscription;
  accountsListData:any={
    data:[]
  };
  originalAccountsListData:any={
    data:[]
  };
  private currentAccount$: Subscription;
  currentAccount:any={
    data:[]
  };
  subAccounts:any = [];
  parentAccount:any = [];

  private versionsData$: Subscription;
  versionsData:any;

  private entitiesData$: Subscription;
  entitiesData:any;
  originalEntitiesData:any = [];

  private accountsStatusData$: Subscription;
  accountsStatus:any;
  accountsStatusData:any;

  private assetMapsData$: Subscription;
  assetMap:any;
  assetMapData:any;

  assetMapHasTotalEstateVals=false;

  private logosData$: Subscription;
  logosData:any;

  user: any;
  showEditable=false;
  pageView = 3;
  pageViews = ['Clean', 'Interim', 'Detail'];
  useNewLayout = false;
  private useNewLayout$: Subscription;
  loadingAccountData = true;
  loadingAccountListData = true;
  isUpdateEntity = false;
  private accountId$: Subscription;
  private sessionName = '';
  private selectedFilters: string[] = [];
  private filterData: any = {};
  isAdmin = false;
  clearSession = false;
  isDev = isDevEnv();
  accountStatusTableDef = {
    title:"Account Status",
    tableName:"AccountStatus",
    pagedOn:true,
    filterOn:true,
    sortOn:true,
    fields:[
      { name: "propertyname",
      label: "Property Name",
      type: "string",
    },
    { name: "propertytext",
      label: "Property Text",
      type: "string",
    },
    { name: "createdby",
    label: "Created By",
    type: "string",
    width: "80px",
    readonly : true
  },
    { name: "created",
    label: "Created",
    type: "datetime",
    align: "center",
    width: "80px",
    readonly : true
  }
    ]
  }

  assetMapTableDef = {
    title:"Asset Map",
    tableName:"AssetMap",
    pagedOn:true,
    filterOn:true,
    sortOn:true,
    fields:[
      { name: "propertyname",
        label: "Property Name",
        type: "string",
      },
      { name: "propertytext",
        label: "Property Text",
        type: "string",
      },
      { name: "createdby",
      label: "Created By",
      type: "string",
      width: "80px",
      readonly : true
    },
      { name: "created",
      label: "Created",
      type: "datetime",
      align: "center",
      width: "80px",
      readonly : true
    }
    ]
  }

  entitiesTableDef = {
    title:"Entities",
    tableName:"Entities",
    pagedOn:true,
    filterOn:true,
    sortOn:true,
    fields:[
      { name: "area",
        label: "Area",
        type: "string",
        width: "120px",
      },
      { name: "servicename",
        label: "Service Name",
        type: "string",
        width: "120px",
      },
      { name: "primarytechnology",
        label: "Primary Technology",
        type: "string",
        width: "120px",
      },
      { name: "secondarytechnology",
        label: "Secondary Technology",
        type: "string",
        width: "120px",
      },
      { name: "provider",
        label: "Provider",
        type: "string",
        width: "120px",
      },
      { name: "coverage",
        label: "Coverage",
        type: "string",
        width: "80px",
      },
      { name: "assetlifecycle",
      label: "Asset EOL",
      type: "string",
      width: "80px",
      },
      { name: "clientfunded",
        label: "Client Funded",
        type: "string",
        width: "80px",
      },
      { name: "servicetenureNum",
        label: "Tenure Of Service",
        type: "string",
        width: "80px",
      },
      { name: "yearslostNum",
        label: "Years Lost",
        type: "string",
        width: "80px",
      },
      { name: "healthstatus",
        label: "Health Status",
        type: "string",
        width: "120px",
      },
      { name: "healthtrend",
        label: "Health Trend",
        type: "string",
        width: "120px",
      },
      { name: "healtheol",
        label: "Health EOL",
        type: "string",
        width: "80px",
      },
      { name: "healtheosl",
        label: "Health EOSL",
        type: "string",
        width: "80px",
      },
      { name: "createdby",
      label: "Created By",
      type: "string",
      width: "80px",
      readonly : true
    },
      { name: "created",
      label: "Created",
      type: "datetime",
      align: "center",
      width: "80px",
      readonly : true
    }
    ]
  }

  groupByFn = item => item.clientclass || 'Rest of Business';

  groupValueFn = (_: string, children: any[]) => ({
    name: children[0].clientclass || 'Rest of Business',
    total: children.length
  });

  constructor(
    public accountService: AccountService,
    public versionService: VersionService,
    public entityService: EntityService,
    public acountsStatusService: AccountStatusService,
    public navigationService: NavigationService,
    public assetMapService: AssetMapService,
    public userService: UserService,
    public logoService: LogoService,
    public dialog: MatDialog,
    library: FaIconLibrary,
    public decPipe: DecimalPipe,
    public pctPipe:PercentPipe,
    public datePipe:DatePipe,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private iconRegistry: MatIconRegistry,
  ) {
    library.addIcons(faDollarSign,faChartLine,faFileExcel,faFilePowerpoint,faProjectDiagram,faInfo,faQuestionCircle,faClipboardList,faMap,faDraftingCompass,faImage,faChevronCircleRight,faChevronCircleLeft,faPlus,faEdit,faCircle,faListOl,faHistory,faEllipsisH,faListAlt,faStar,faExpandArrowsAlt,faPlus,faMinus,faFileDownload,faFileImage,faFileUpload,faFilePdf,faSearch, faRedo, faSitemap, faExchangeAlt);
    this.iconRegistry.addSvgIconLiteral('Clean-view-icon', this.sanitizer.bypassSecurityTrustHtml(CLEAN_VIEW_ICON));
    this.iconRegistry.addSvgIconLiteral('Interim-view-icon', this.sanitizer.bypassSecurityTrustHtml(INTERIM_VIEW_ICON));
    this.iconRegistry.addSvgIconLiteral('Detail-view-icon', this.sanitizer.bypassSecurityTrustHtml(DETAIL_VIEW_ICON));
  }

  ngOnInit(): void {
    this.useNewLayout$ = this.navigationService.useNewLayout$.subscribe((useNewLayout: any) => {
      if (typeof useNewLayout === 'boolean' && this.useNewLayout !== useNewLayout) {
        this.toggleLayout(useNewLayout);
      }
    });

      this.accountService.resetAccounts();

      // wire up the querystring handler - use a flag to ignore when the qs is set in the app
      // only need to handle if it is done in the initial load or in the naviation (forward and back)
      this.activatedQuery$ = this.activatedRoute.queryParamMap.subscribe(params => {
        // console.log(">>handle>>" + this.handlenavigate)
        if(this.handlenavigate){
          // console.log("---- do it ----");
          this.setStateFromQS(params);
          this.handlenavigate = true;
        } else {
          // ignore! it was just the query string updating, reset
          // console.log("---- ignore ----");
          this.handlenavigate = true;
        }
      })



    // wire up the logos
    this.logosData$ = this.logoService.logos$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(responsedata.loading){
            this.pushLoading();
          } else {
            this.logosData = responsedata["data"];
            this.popLoding();
          }
        }
      }
    )
    this.logoService.loadLogos();

    this.userService.user$.subscribe(data => {

      // console.log("userX > " + JSON.stringify(data))
      if(data!=null){
      this.user = data[0];
      this.showRestrictedFilter = this.user.restricted;
      this.isAdmin = this.user.usertype === 'Admin';
      this.isLoadingUser = false;

      this.setIsEditable();
    }
    });

    // wire up the accounts and load them
    this.accountsData$ = this.accountService.accounts$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(!responsedata.loading) {
            if(!responsedata.filter) {
              this.accountsData = responsedata;
              this.originalAccountsData = responsedata;
              this.loadingAccountData = false;
              if (this.init && !this.loadingAccountListData) {
                // -- on initial load handle the query string for the state
                let qs = this.activatedRoute.snapshot.queryParamMap
                this.getAccountByQs(qs);
              }
            } else {
              if(responsedata['data'] && this.originalAccountsData) {
                let result = [];
                responsedata['data'].forEach(item => {
                  for(let i=0; i < this.originalAccountsData['data'].length; i++) {
                    let element = this.originalAccountsData['data'][i];
                    if(item.id == element.id) {
                      result.push(element);
                      break;
                    }
                  }
                });
                this.accountsData = {
                  data: result
                };
              }
            }
          }
        }
      }
    );
    this.accountService.loadAccounts();

    // wire up the accountslist and load them
    this.accountsListData$ = this.accountService.accountsList$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(!responsedata.loading) {
            if(!responsedata.filter) {
              this.accountsListData.data = responsedata.data[0].dataitems ? this.buildAccountList(JSON.parse(responsedata.data[0].dataitems)) : [];
              this.accountsListData['loading'] = responsedata.loading;
              this.originalAccountsListData = this.accountsListData;
              this.loadingAccountListData = false;
              if (this.init && !this.loadingAccountData) {
                // -- on initial load handle the query string for the state
                let qs = this.activatedRoute.snapshot.queryParamMap
                this.getAccountByQs(qs);
              }
            } else {
              if(responsedata['data'] && responsedata['data'].length>0 && this.originalAccountsListData) {
                let tempData = responsedata.data[0].dataitems ? this.buildAccountList(JSON.parse(responsedata.data[0].dataitems)) : [];
                let result = [];
                tempData.forEach(item => {
                  for(let i=0; i < this.originalAccountsListData.data.length; i++) {
                    let element = this.originalAccountsListData.data[i];
                    if(item.id == element.id) {
                      result.push(element);
                      break;
                    }
                  }
                });
                this.accountsListData = {
                  data: result
                };
              }
            }
          }
        }
      }
    );
    this.accountService.loadAccountsList();

    this.currentAccount$ = this.accountService.currentAccount$.subscribe(
      (responsedata: any) => {
        if(responsedata){
          this.subAccounts = [];
          this.parentAccount = [];
          if(responsedata.loading){
            
          } else {
            if(responsedata["data"].length>0){
              this.currentAccount = responsedata["data"][0];
              if(this.currentAccount.relations){
                let rela = JSON.parse(this.currentAccount.relations);
                if(rela.length>0){
                  let tempChild = [];
                  let tempParent = [];
                  rela.forEach(item => {
                    if(item.relation == 'child'){
                      tempChild.push(item);
                    }
                    if(item.relation == 'parent'){
                      tempParent.push(item);
                    }
                  });
                  this.subAccounts = tempChild;
                  this.parentAccount = tempParent;
                }
              }
            }    
          }
        }
      }
    );

    // wire up the versions
    this.versionsData$ = this.versionService.versions$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(responsedata.loading){
            this.pushLoading();
            this.isData = true;
          } else {
            this.versionsData = responsedata["data"];

            // set the selected version to the last one and load the data
            if(this.versionsData.length==0){
              this.sVersion=0;
              this.sVersionName = "";
              this.loadAccountData();
            } else {

              // if the version came from the querystring then make sure it exists
              // and select it - if doesn't exist OR no val from qs then just get the latest one
              let sVid = this.versionsData[0]["id"];
              let sVname = "";
              if(this.sVersionInitId!=null){
                this.versionsData.forEach(x => {
                  if(x["id"] == this.sVersionInitId){
                    sVid = x["id"]
                    sVname = x["name"]
                  }
                });
                // set the init val to null so it doesn't get picked up after init
                this.sVersionInitId = null;
              }

              this.sVersion = sVid;
              this.sVersionName = sVname;
              this.loadAccountData();
            }

            // reset the editable as we are loading the current version
            this.setIsEditable();
            this.popLoding();
          }
        }
      }
    );


    // wire up the entities
    this.entitiesData$ = this.entityService.entities$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(responsedata.loading){
            if (responsedata.updateOrDelete) {
              this.isUpdateEntity = true;
            } else {
              this.pushLoading();
            }
            this.isData = true;
          } else {
            this.isUpdateEntity = false;
            this.entitiesData = [...responsedata["data"]];
            this.entitiesData.forEach(entity => {
              addEntityProperty(entity);
            });

            // add the client logo to each of the entities
            // so the entity can use the client logo if there is one
            // console.log("-->" + JSON.stringify(this.sAccount));
            if(this.sAccount && this.sAccount["logo"]){
              this.entitiesData.forEach(x => {
                x["clientlogo"] = this.sAccount["logo"];
              });
            }
            this.originalEntitiesData = this.deepCopyArray(this.entitiesData);
            this.popLoding();
          }
        }
      }
    );


    // wire up the account status values
    this.accountsStatusData$ = this.acountsStatusService.accountsStatus$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(responsedata.loading){
            this.isLoadingStatus = true;
            this.pushLoading();
            this.isData = true;
            this.finishLoadingStatus = true;
          } else {
            this.accountsStatusData = responsedata["data"];
            // turn the array returned into an object
            this.accountsStatus = {};
            responsedata["data"].forEach(x => {
              this.accountsStatus[x["propertyname"]] = x;
            });

            if (this.finishLoadingStatus) {
              this.isLoadingStatus = false;
            }
            this.popLoding();
          }
        }
      }
    );

        // wire up the asset Map values
        this.assetMapsData$ = this.assetMapService.assetMap$.subscribe(
          (responsedata: any) => {
            if(responsedata!=null){
              if(responsedata.loading){
                this.pushLoading();
                this.isData = true;
              } else {
                // turn the array returned into an object
                // also see if the data has any total estate vals
                // if it does then we should both values on the page
                // for all of the values

                this.assetMap = responsedata["data"];
                this.assetMapData = {};
                this.assetMapHasTotalEstateVals = false;

                responsedata["data"].forEach(x => {
                  this.assetMapData[x["propertyname"]] = x;
                });
                this.popLoding();
              }
            }
          }
        );

    this.stackColors$ = this.entityService.stackColors$.subscribe((res: any) => {
      if(res && !this.offeringLayersLoaded){
        if (res.loading) {
          this.pushLoading();
          this.isData = true;
        } else {
          this.offeringLayersLoaded = true;
          if (Array.isArray(res.data) && res.data.length) {
            this.stackColors = res.data;
          }
          this.popLoding();
        }
      }
    });

    this.navigationService.showMenu$.subscribe(val => {
      this.calculateScale();
    });

    this.accountId$ = this.accountService.accountId$.subscribe((res: any) => {
      if (res && !res.loading) {
        if (Array.isArray(res.data) && res.data.length === 1) {
          const account = res.data[0];
          this.handleRedirect(account, () => {
            const qs = this.activatedRoute.snapshot.queryParamMap;
            this.redirectToAccount(qs);
            this.init = false;
          });
        } else {
          const { params: { c, s, i, f } } = this.activatedRoute.snapshot.queryParamMap as any;
          const params = {
            code: c,
            sfdcglobalid: s,
            accountID: i,
            casesafeid: f
          };
          this.handleRedirect(null, () => {
            const currentFilters = this.getFilterSession();
            let selectedFilters = [];
            if (Array.isArray(currentFilters.selectedFilters)) {
              selectedFilters = currentFilters.selectedFilters;
            }
            sfdcAccountFilters.forEach(itm => {
              if (params[itm]) {
                this.filterData[itm] = params[itm];

                if (!selectedFilters.includes(itm)) {
                  selectedFilters.push(itm);
                }
              }
            });
            this.selectedFilters = selectedFilters;
            this.setFilterSession();
            this.clearSession = !this.isAdmin;
            this.init = false;
          });
        }
      }
    });
  }

  ngAfterViewInit(): void {
    window.addEventListener('resize', this.calculateScale);
  }

  ngOnDestroy(): void {
    this.activatedQuery$.unsubscribe();
    this.accountsData$.unsubscribe();
    this.versionsData$.unsubscribe();
    this.entitiesData$.unsubscribe();
    this.accountsStatusData$.unsubscribe();
    this.assetMapsData$.unsubscribe();
    this.logosData$.unsubscribe();
    this.accountService.resetAccounts();
    this.currentAccount$.unsubscribe();
    this.accountsListData$.unsubscribe();
    this.stackColors$.unsubscribe();
    this.useNewLayout$.unsubscribe();
    this.accountId$.unsubscribe();
    this.accountService.accountId$.next(null);
    window.removeEventListener('resize', this.calculateScale);
  }

  setIsEditable(){
      // Decide if the user can see editable elements also checked on the backend - this is just to adjust the UI
      this.showEditable = this.userCanEdit();
  }

  userCanEdit(){
    if(this.sAccount && this.sAccount.useraccess=="W"){
      return true;
    } else {
      return false;
    }
  }

  pushLoading(){
    this.loading++;
    // console.log("push:"+this.loading)
    this.isLoading = true;
  }

  popLoding(){
    this.loading--;
    // console.log("pop:"+this.loading)
    if(this.loading<=0){
      this.loading=0;
      this.isLoading = false;
      this.calculateScale();
    }
  }

  pageUp(){
    this.page++;
    //update NavService so it can pick the right help page
    this.navigationService.setLandscapePage(this.page);
    this.updateQS();
    var self = this;
    if (this.isFitPage) {
      self.fitPage();
    }

    if (this.page !== 3) {
      this.calculateScale();
    }
  }

  pageDown(){
    this.page--;
    //update NavService so it can pick the right help page
    this.navigationService.setLandscapePage(this.page);
    this.updateQS();
    var self = this;
    if (this.isFitPage) {
      self.fitPage();
    }

    if (this.page !== 2) {
      this.calculateScale();
    }
  }

  print(){
    const winRef = window.open('/print?a=' + this.sAccount["id"] + "&v=" + this.sVersion + `&layout=${this.useNewLayout ? 'new' : 'old'}`, '_blank','');
  }

  excel(){
    const apiUrl = this.useNewLayout ? '/api/excelnew/export' : '/api/excel/export';
    const dUrl = `${apiUrl}?a=${this.sAccount['id']}&v=${this.sVersion}`;
    
    const exportDialogRef = this.dialog.open(ImportDialogComponent, {
      width: '350px',
      height: '300px',
      data: {title:"Export", text: "Generating Excel File ...", loading:true}
    });

    fetch(dUrl)
      .then(resp => resp.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;        
        a.download = 'EM-' + this.sAccount["name"] + '-Export.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        
        exportDialogRef.componentInstance.data = {title:"Export", text: "Excel Exported", loading:false};
        exportDialogRef.close();
      })
      .catch((err) => {
        exportDialogRef.componentInstance.data = {title:"Export", text: "Problem with the exporting<br>" + err.error["Message"].replace(/\|/g,"</br>"), loading:false};
        return throwError(err);
      });

  }

  powerpoint(){
    const apiUrl = '/api/powerpointnew/export';
    let dUrl = `${apiUrl}?a=${this.sAccount['id']}&v=${this.sVersion}`;
    
    const exportDialogRef = this.dialog.open(ImportDialogComponent, {
      width: '350px',
      height: '300px',
      data: {title:"Export", text: "Generating PowerPoint File ...", loading:true}
    });

    fetch(dUrl)
      .then(resp => resp.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;        
        a.download = 'EM-' + this.sAccount["name"] + '-Export.pptx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        
        exportDialogRef.componentInstance.data = {title:"Export", text: "PowerPoint Exported", loading:false};
        exportDialogRef.close();
      })
      .catch((err) => {
        exportDialogRef.componentInstance.data = {title:"Export", text: "Problem with the exporting<br>" + err.error["Message"].replace(/\|/g,"</br>"), loading:false};
        return throwError(err);
      });
  }
  
  public uploadFile = (files) => {
    if (files.length == 0) {
      return;
    }

    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    const importDialogRef = this.dialog.open(ImportDialogComponent, {
      width: '350px',
      height: '300px',
      data: {title:"Import", text: "Importing Excel File ...", loading:true}
    });

    importDialogRef.afterClosed().subscribe(result => {
      // reload the version data - this will get the latest one
      this.versionService.loadVersions(this.sAccount["id"]);
    })

    const apiUrl = this.useNewLayout ? '/api/excelnew/import' : '/api/excel/import';
    const url = `${apiUrl}?a=${this.sAccount['id']}`;

    this.http.post(url, formData, {reportProgress: true, observe: 'events'})
      .pipe(catchError(err => {
        importDialogRef.componentInstance.data = {title:"Import", text: "Problem with the excel load:<br>" + err.error["Message"].replace(/\|/g,"</br>"), loading:false};
        return throwError(err);
      })

      )
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress){
         //  this.progress = Math.round(100 * event.loaded / event.total);
        }
        else if (event.type === HttpEventType.Response) {
          importDialogRef.componentInstance.data = {title:"Import", text: event.body["message"].replace(/\|/g,"</br>"), loading:false};
        }
      })


  }

  selectAccount(event, addPageParam: boolean = true){
    if(event===undefined) return;
    const item = this.accountsData['data'].find(itm => itm.id === event.id);

    this.sAccount = item? item:event;
    // update the editable flag
    this.setIsEditable();

    // load the versions - this will load the data
    this.versionService.loadVersions(this.sAccount["id"]);

    // update the query string to reflect selected account
    this.updateQS(addPageParam);
  }

  loadAccountData(){
    // load the data
    if(this.sAccount){
      this.entityService.loadEntities(this.sAccount["id"],this.sVersion);
      this.acountsStatusService.loadStatus(this.sAccount["id"],this.sVersion);
      this.assetMapService.loadAssetMap(this.sAccount["id"],this.sVersion);
      this.accountService.loadCurrentAccount(this.sAccount["id"]);
      if (!this.offeringLayersLoaded) {
        this.entityService.loadStackColors();
      }
    }
  } 

  // deep copy of Object
  private deepCopy(obj) {
    return Object.keys(obj).reduce((v, d) => Object.assign(v, {
      [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
    }), {});
  }

  private deepCopyArray(arr){
    let narray = [];
    arr.forEach(el => {
      narray.push(this.deepCopy(el))
    });
    return narray
  }

  openVersions(){

    let data = {
      sVersion: this.sVersion,
      showEditable: this.userCanEdit(),
      account: this.sAccount
    }

    let dialogRef = this.dialog.open(VersionsComponent, {
      height: '600px',
      width: '700px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result && result["action"]){
        if(result["action"]=="select"){
          this.sVersion = result["versionid"];

          // if it isn't the most up to date version, switch off editing
          // if it is then switch it on if the user is allowed
          if(this.versionsData[0]["id"] == this.sVersion){
            this.setIsEditable();
            this.sVersionName = "";
          } else {
            this.showEditable = false;
            this.sVersionName = result["name"];
          }

          // update the query string to reflect selected version
          this.updateQS();

          this.loadAccountData()

        } else if(result["action"]=="cancel"){
          // don't do anything
        }
      }

    })
  }

  openAccount(){
  }




    zoomFit(){

      // width is around 1700 - just do width for now - todo, add height! also
      // calculate the 1700 - can be more if there is more on the page
      this.fitPage()
      this.isFitPage=true
    }
    fitPage() {
      this.zoom = 100;
    }
    zoomPlus(){
      // Fix this to step to the nearest step then go up by 10
      this.isFitPage=false
      if(this.zoom<200) {
        if(this.zoom % 5 ==0){
          this.zoom = this.zoom+5;
        } else {
          this.zoom = (Math.floor(this.zoom / 5) * 5) + 5
        }
      }
    }

    zoomMinus(){
      this.isFitPage=false
      if(this.zoom>10) {
        if(this.zoom % 5 ==0){
          this.zoom = this.zoom-5;
        } else {
          this.zoom = (Math.floor(this.zoom / 5) * 5)
        }
      }
    }

    addEntity(){
      this.slView.addEntity();
    }

    openStatusEdit(){
      this.slUseCases.openStatusEdit();
    }

    openAssetMapEdit(){
      this.slAssetMap.openAssetMapEdit();
    }


    getLogo(account:Object){
      if(account==undefined || account==null) return "";
      let rtn = "";
      if(this.logosData) {
        this.logosData.forEach(x => {
          if(x.name==account["logo"]) {
            rtn = x.file
          }
        });
      }
      return rtn;
    }

    DuplicateRemoval(OldArray) {
      let b = [];
      let arr = OldArray.concat(b)
      let NewArray = []
      let obj = {}
      for(let i of arr) {
        if(!obj[i]) {
          NewArray.push(i)
          obj[i] = 1
        }
      }
      return NewArray;
    }

  getAccountByQs(qs) {
    const { params: { a: accountId, c, s, i, f } } = qs;
    if (accountId) {
      this.redirectToAccount(qs);
      this.init = false;
    } else {
      if (c || s || i || f) {
        const data = {
          code: c,
          sfdcglobalid: s,
          accountID: i,
          casesafeid: f
        };
        this.accountService.getAccountByClientInfo(data);
      } else {
        this.init = false;
      }
    }
  }

  handleRedirect(account, callback) {
    const params = {
      c: null,
      s: null,
      i: null,
      f: null
    };

    if (account && account.id) {
      params['a'] = account.id;
    }

    this.handlenavigate = false;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: params,
      queryParamsHandling: 'merge',
      skipLocationChange: false,
      replaceUrl: true
    }).then(e => {
      this.handlenavigate = true;
      if (typeof callback === 'function') {
        callback();
      }
    });
  }

  redirectToAccount(qs) {
    let params = qs["params"];

    // accountid
    if (params["a"]) {
      this.originalAccountsListData['data'].forEach(x => {
        if(x["id"] == params["a"] && !x.disabled){
          this.sAccountInitId = x["id"];
          let addPageParam = false;
          if (params['p'] && (params['p'] == '1' || params['p'] == '2'|| params['p'] == '3' || params['p'] == '4' || (this.isDev && params['p'] == '5'))) {
            this.page = params['p'];
            addPageParam = true;
          }
          this.selectAccount(x, addPageParam);
        }
      });
    }

    this.updateLandscapeConfig();
  }

  setStateFromQS(qs) {
    let params = qs["params"]

    // page - must be 1,2,3,4 - otherwise just leave it as is
    if (params["p"]) {
      if(params["p"]=="1"||params["p"]=="2"||params["p"]=="3"||params["p"]=="4"||(this.isDev && params["p"]=="5")){
        this.page = params["p"];
      }
    } else {
      this.page = 1;
    }

    // accountid
    if (params["a"]) {
      this.originalAccountsListData["data"].forEach(x => {
        if(x["id"] == params["a"] && !x.disabled){
          // set the initial value of the dropdown
          const item = this.accountsData['data'].find(itm => itm.id === x.id);
          this.sAccount = item ? item : x;
          this.sAccountInitId = item ? x["id"] : null;
        }
      });

      // versionid - defaults to latest
      this.sVersionInitId = null;
      if (params["v"]) {
        this.sVersionInitId = params["v"];
      }

      if(this.sAccount!=null){
        this.versionService.loadVersions(this.sAccount["id"]);
      }
    } else {
      this.handlenavigate = false;
      this.reset();
    }

    this.updateLandscapeConfig();
  }

  updateQS(addPageParam: boolean = true) {

    let o = {}
    if (this.sAccount != null) {
      o["a"] = this.sAccount["id"];
    } else {
      o["a"] = null;
    }

    // if the version isn't the latest one and there is more than one version then add to the querystring
    if (this.versionsData && this.versionsData.length>0 && this.sVersion != this.versionsData[0]["id"]) {
      o["v"] = this.sVersion;
    } else {
      o["v"] = null;
    }

    if (addPageParam) {
      o["p"] = this.page;
    }

    // update the querystring and let the handler know to ignore
    this.handlenavigate = false;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: o,
      queryParamsHandling: 'merge',
      skipLocationChange:false,
      replaceUrl:false
    }).then(e => {
      this.handlenavigate = true;
    });

    this.updateLandscapeConfig();
  }

  reset() {
    if (!this.sAccount) {
      this.accountsData = this.originalAccountsData;
      this.accountsListData = this.originalAccountsListData;
    }

    this.sAccountInitId = null;
    this.sAccount = null;
    this.versionsData = null;
    this.sVersion = null;
    this.sVersionInitId = null;
    this.sVersionName = '';
    this.page = 1;
    this.isData = false;
    this.pageView = this.useNewLayout ? 1 : 3;
    // this.updateQS();

    this.router.navigate([]).then(e => {
      if (e) {
        console.log("Navigation is successful");
      }
      else {
        console.log("failed to navigate");
      }
    });
  }

  searchFn = (value: string, item: any) => {
    const { name, short, childString} = item;
    const val = (value || '').toLowerCase();
    const accountName = (name || '').toLowerCase();
    const shortName = (short || '').toLowerCase();
    const childStr = (childString || '').toLowerCase();
    return accountName.includes(val) || shortName.includes(val) || childStr.includes(val);
  }
  searchTextChange(e){
    const searchText = e&&e.term?e.term.trim():'';
    if(searchText==""){
      this.matTooltipShow = true;
    }else{
      this.matTooltipShow = false;
    }
  }
  displayMatooltip(){
    this.matTooltipShow = true;
  }
  viewAccounts(role){
    let data = {
      title: role=="child"? "Related Accounts":"Parent Account",
      data: role=="child"? this.subAccounts:this.parentAccount,
    }
    let newdata = this.deepCopy(data);
    let dialogRef = this.dialog.open(SubAccountComponent, {
      height: '600px',
      width: '500px',
      data: newdata
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result=="cancel"){
      } 
    });
  }

  buildAccountList(data){ 
    let dropdownList = [];
    data.forEach(item => {
      if(item.accounts.length>0){
        item.accounts.forEach(ac => {
          ac.clientclass = item.name;
          if(ac.hasright==0){
            ac['disabled'] = true;
          }
          dropdownList.push(ac);
          ac['childString'] = "";
          if(ac.childs&&ac.childs.length>0){
            ac.childs.forEach(d => {
              if(d["id"]){
                ac['childString'] = ac['childString'] + d['name']+";"+d['short']+";";
                d['parentid'] = ac.id;
                d['clientclass'] = item.name;
                dropdownList.push(d);
              }
            });
          }
        });
      }
    });
    return dropdownList;
  }

  updatePageView() {
    if (this.pageView < 3) {
      this.pageView++;
    } else {
      this.pageView = 1;
    }

    this.updateLandscapeConfig();
  }

  toggleLayout(useNewLayout: boolean) {
    this.useNewLayout = useNewLayout;
    if (this.useNewLayout) {
      this.pageView = 1;
    } else {
      this.pageView = 3;
    }

    this.updateLandscapeConfig();

    if (this.isFitPage) {
      this.fitPage();
    }

    this.calculateScale();
  }

  updateLandscapeConfig() {
    this.navigationService.setLandscapeConfig(this.isData && (this.page == 2 || this.page == 3), this.page, this.useNewLayout, this.pageView, this.sAccount);
  }

  getPageViewTooltip() {
    let tooltip = '';

    switch (this.pageView) {
      case 1:
        tooltip = 'Simple';
        break;
      case 2:
        tooltip = 'Annotated';
        break;
      case 3:
        tooltip = 'All Entries';
        break;
      default:
        break;
    }

    return tooltip;
  }

  toggleTableView() {
    this.calculateScale();
  }

  getScale() {
    const zoom = Math.floor(this.scale * this.zoom * 100) / 100;
    return zoom / 100;
  }

  calculateScale: any = (event: any) => {
    this.fitWidth = true;
    this.fitHeight = true;
    this.tempZoom = this.zoom;
    this.zoom = 100;
    this.scale = 1;
    setTimeout(() => {
      const stageElement = document.getElementsByClassName("stage")[0];
      const stageViewElement = document.getElementsByClassName("stage-view")[0];
      if (stageElement && stageViewElement) {
        const { clientWidth, clientHeight } = stageElement;
        const { scrollWidth, scrollHeight } = stageViewElement;
        this.zoom = this.tempZoom;

        if (clientWidth !== scrollWidth) {
          const scale = Math.floor(((clientWidth - 5) / scrollWidth) * 1000) / 1000;
          this.scale = scale;
        }

        this.fitWidth = clientWidth > scrollWidth;
        this.fitHeight = clientHeight > scrollHeight;
      }
    }, 50);
  }

  getFilterSession() {
    this.sessionName = initSessionName();
    const session = window.sessionStorage.getItem(this.sessionName);
    if (session) {
      return JSON.parse(session);
    } else {
      return {};
    }
  }

  setFilterSession() {
    const data = JSON.parse(JSON.stringify(this.filterData));
    const filters = {
      ...data,
      selectedFilters: JSON.parse(JSON.stringify(this.selectedFilters))
    };
    window.sessionStorage.setItem(this.sessionName, JSON.stringify(filters));
  }

  resetSessionFlag() {
    this.clearSession = false;
  }
}
